export function useCustomEvents() {
  const subscribeEvent = (
    eventName: string,
    listener: (e: CustomEvent) => void
  ) => {
    document.addEventListener(eventName, listener);
  };

  function unsubscribeEvent(eventName: string, listener: () => void) {
    document.removeEventListener(eventName, listener);
  }

  function triggerEvent(eventName: string, data?: {}) {
    const event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
  }
  return {
    triggerEvent,
    subscribeEvent,
    unsubscribeEvent,
  };
}
